export default "__VITE_ASSET__cbd00318__"